import { Component, input } from '@angular/core';

// Dossier d'un agent cible ou responsable : portrait, identite et action.
// Le contenu projete (boutons, compte a rebours) s'affiche sous l'action.
@Component({
  selector: 'app-target-card',
  styleUrl: './target-card.scss',
  templateUrl: './target-card.html',
})
export class TargetCard {
  readonly heading = input.required<string>();
  readonly icon = input<'crosshair' | 'warning'>('crosshair');
  readonly nameLabel = input('Identité');
  readonly name = input<string | null>(null);
  readonly aside = input<string | null>(null);
  readonly actionLabel = input('Action à réaliser');
  readonly action = input<string | null>(null);
  readonly stamp = input<string | null>(null);
  readonly portrait = input(true);
}
